var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4043 12.8215L11.0848 9.50195C11.0219 9.43906 10.9398 9.40625 10.8523 9.40625H10.4914C11.3527 8.4082 11.875 7.10938 11.875 5.6875C11.875 2.5457 9.3293 0 6.1875 0C3.0457 0 0.5 2.5457 0.5 5.6875C0.5 8.8293 3.0457 11.375 6.1875 11.375C7.60938 11.375 8.9082 10.8527 9.90625 9.99141V10.3523C9.90625 10.4398 9.9418 10.5219 10.002 10.5848L13.3215 13.9043C13.45 14.0328 13.6578 14.0328 13.7863 13.9043L14.4043 13.2863C14.5328 13.1578 14.5328 12.95 14.4043 12.8215ZM6.1875 10.0625C3.77031 10.0625 1.8125 8.10469 1.8125 5.6875C1.8125 3.27031 3.77031 1.3125 6.1875 1.3125C8.60469 1.3125 10.5625 3.27031 10.5625 5.6875C10.5625 8.10469 8.60469 10.0625 6.1875 10.0625Z",
    fill: "#99ADBA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrey);
export default __webpack_public_path__ + "static/media/SearchGrey.e0ddad5e.svg";
export { ForwardRef as ReactComponent };